import { useState } from 'react';
import { useMount } from 'ahooks';
import { fetchCOSPath } from '@intelligence/pages/LowCodeTemplateDataJson/utils';
import { createRetryWrapper } from '@intelligence/v3/utils/enhancer';

const fetchCOSPathRetryable = createRetryWrapper(fetchCOSPath);

export default function useLowCodeTemplateConfig(configKey: string) {
  const [loading, setLoading] = useState(true);

  const [error, setError] = useState<Error | null>(null);

  const [configMap, setConfigMap] = useState<IRecord>({});

  const updateConfigMap = async () => {
    try {
      setLoading(true);
      const res = await fetchCOSPathRetryable();
      const newConfigMap = res?.data?.configure_texts?.lowcode_template || {};
      setConfigMap(newConfigMap);
    } catch (error) {
      console.error(error);
      setError(error as unknown as Error);
    } finally {
      setLoading(false);
    }
  };

  useMount(() => {
    void updateConfigMap();
  });

  return { loading, error, config: configMap?.[configKey] };
}
